<template>
  <div class="assembly-item-container">
    <div v-if="!isRootLevel && firstChild" class="assembly-item-child-branch">
      <div class="assembly-item-branch-circle"></div>
      <div class="assembly-item-branch-line"></div>
    </div>
    <div :class="{'assembly-item-child': isChildItem}">
      <div class="assembly-item" @click="assemblyItemClicked(assemblyItem)">
        <div :class="['assembly-item-icon', iconContainerClass]">
          <i :class="['fas', 'fa-fw', iconClass]"></i>
        </div>
        <div class="assembly-item-line" v-if="editing || !lastChild || isRootLevel || hasChildItems">
        </div>
        <div class="assembly-item-info">
          <div class="title">{{formatLookupName(assemblyItem.stockType, InventoryStockTypeLookup)}}</div>
          <div class="description" v-if="assemblyItem.description"><i class="far fa-info-circle"></i>  {{assemblyItem.description}}</div>

          <template v-if="!editing">            
            <div class="description" v-if="isItemQuantityAvailable"><i class="far fa-calculator"></i>  Quantity: {{assemblyItem.quantity}}</div>
            <div class="description" v-if="assemblyItem.generatedDescription"><i class="far fa-info-circle"></i> {{assemblyItem.generatedDescription}}</div>
          </template>
          
        </div>
        <div class="assembly-item-actions" v-if="editing">
          <button class="btn" @click.stop="assemblyItemDeleteClicked(assemblyItem)"><i class="fas fa-trash"></i></button>
        </div>
      </div>
      <div class="assembly-item-spacer">
        <div :class="['assembly-item-spacer-line', (!editing && lastChild && !isRootLevel && hasChildItems) ? 'assembly-last-child-branch' : '']" v-if="editing || !lastChild || isRootLevel || hasChildItems" />
        <div class="assembly-item-spacer-insert" v-if="editing && !lastChild" @click.stop="assemblyItemInsertClicked(assemblyItem)">
          <div class="content">
            <i class="far fa-plus-circle"></i> Insert
          </div>
        </div>
        <div class="assembly-item-spacer-insert assembly-item-spacer-insert-child" v-if="editing && hasChildItems" @click.stop="assemblyItemInsertChildClicked(assemblyItem)">
          <div class="content">
            <i class="far fa-plus-circle"></i> Insert
          </div>
        </div>

        <StockAssemblyItem
          v-for="(child, index) of childrenItems"
          :key="child.id"
          :editing="editing"
          :level="level+1" 
          :parentItemId="assemblyItem.id"
          :assemblyItem="child"
          :firstChild="index == 0"
          :lastChild="index == childrenItems.length-1"
          @itemClicked="assemblyItemClicked($event)"
          @deleteClicked="assemblyItemDeleteClicked($event)"
          @insertClicked="assemblyItemInsertClicked($event)"
          @insertChildClicked="assemblyItemInsertChildClicked($event)"
          @addItem="assemblyItemAddClicked($event)"
        />

        <!-- Special add to empty branch -->
        <div v-if="editing && !hasChildItems && canAddChildItem" class="assembly-item-add-empty-branch">
          <div class="assembly-item-child-branch">
            <div class="assembly-item-branch-circle"></div>
            <div class="assembly-item-branch-line"></div>
          </div>
          <div :class="['assembly-item-container', {'assembly-item-child': true}]">
            <button class="assembly-item-add-button" v-if="editing" @click.prevent="assemblyItemAddClicked(assemblyItem.id)">
              <div class="add-button-circle"></div>
              <div class="add-button-text">Add Sub Item</div>
            </button>
          </div>
        </div>
        
      </div>
      <div v-if="lastChild">
        <button class="assembly-item-add-button" v-if="editing" @click.prevent="assemblyItemAddClicked(parentItemId)">
          <div class="assembly-item-spacer-line" />
          <div class="add-button-circle"></div>
          <div class="add-button-text">Add Item</div>
        </button>
        
        <div class="assembly-item-endpoint" v-if="!editing && isRootLevel">
          End Assembly
        </div>

      </div>
    </div>

  </div>
</template>


<script>
import { InventoryStockTypes, InventoryStockTypeLookup, StockAssemblyJoinTypeLookup, UOMTypes } from '@/store/types'

export default {
  name: 'StockAssemblyItem',
  props: {
    level: {
      type: Number,
      default: 0
    },
    parentItemId: [Number, String],
    assemblyStockItem: Object,
    rootAssemblyData: Object,
    assemblyItem: Object,
    editing: Boolean,
    firstChild: Boolean,
    lastChild: Boolean
  },
  computed: {
    isAssemblySquareMetreUOM() {
      return this.assemblyStockItem.uomType == UOMTypes.metresq
    },
    isRootLevel() {
      if(!this.assemblyItem)
        return false
      return this.assemblyItem.parentId == null
    },
    isChildItem() {
      return this.parentItemId != null && this.parentItemId != ''
    },
    childrenItems() {
      return this.assemblyItem.childItems || []
    },
    hasChildItems() {
      return this.childrenItems.length > 0
    },
    canAddChildItem() {
      return (this.assemblyItem.stockType == InventoryStockTypes.glass || this.assemblyItem.stockType == InventoryStockTypes.assembly)
    },
    iconContainerClass() {
      return `assembly-item-${this.assemblyItem.stockType}`      
    },
    iconClass() {
      switch(this.assemblyItem.stockType) {
        case InventoryStockTypes.glass:
          return 'fa-layer-group'
        case InventoryStockTypes.glassService:
          return 'fa-tools'
        case InventoryStockTypes.general:
          return 'fa-box-up'
        case InventoryStockTypes.assembly:
          return 'fa-clipboard-list-check'
      }
      return ''
    },
    isItemGlass() {
      return this.assemblyItem.stockType == InventoryStockTypes.glass
    },
    isItemQuantityAvailable() {
      // Glass is fixed to 1 item
      // Stock not using each has no quantity
      if(this.assemblyItem.stockType == InventoryStockTypes.glass)
        return false

      // Only display if not 1
      // Will be set via dialog
      return this.assemblyItem.quantity > 1
    },    
  },
  created() {
    this.InventoryStockTypeLookup = InventoryStockTypeLookup
    this.StockAssemblyJoinTypeLookup = StockAssemblyJoinTypeLookup
  },
  methods: {
    assemblyItemClicked(assemblyItem) {
      this.$emit('itemClicked', assemblyItem)
    },
    assemblyItemDeleteClicked(assemblyItem) {
      this.$emit('deleteClicked', assemblyItem)
    },
    assemblyItemInsertClicked(assemblyItem) {
      this.$emit('insertClicked', assemblyItem)
    },
    assemblyItemInsertChildClicked() {
      // Get first child
      if(this.childrenItems.length > 0)
        this.$emit('insertChildClicked', this.childrenItems[0])
    },
    assemblyItemAddClicked(parentId) {
      this.$emit('addItem', parentId)
    }
  }
}
</script>